










import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'TitleModel',
  props: {
    titleData: {
      type: Object,
      defalut: {}
    },
    clickMore: {
      type: Object,
      defalut: () => {}
    },
  },
  components: {
  },
  setup(props: any, { emit }: any) {
    const checkMore = () => {
      console.log('1111', props.titleData.urlPath);
      emit('clickMore', props.titleData.urlPath);
    };
    return {
      checkMore
    };
  },
});
